/* eslint-disable no-negated-condition */
/* eslint-disable camelcase */
import assign from "lodash/fp/assign";
import isNil from "lodash/fp/isNil";
import constants from "../../core/constants";
import find from "lodash/fp/find";
import { mapKeyValue } from "../../core/transforms";
import startCase from "lodash/fp/startCase";
import cloneDeep from "lodash/fp/cloneDeep";
import {
  toMilliseconds,
  multiplyFloatingPointByCurrency,
} from "../../core/utils";
import apis from "../../core/apis";
import { saveAs } from "file-saver";

class Controller {
  constructor($injector, $stateParams, $mdDialog, Lists, Upload) {
    "ngInject";
    this.Lists = Lists.all;
    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;
    this.City = $injector.get("City");
    this.Events = $injector.get("Events");
    this.Station = $injector.get("Station");
    this.Messages = $injector.get("Messages");
    this.District = $injector.get("District");
    this.sections = $injector.get("Sections").settingsSections;
    this.CityTransforms = $injector.get("CityTransforms");
    this.DistrictsTransforms = $injector.get("DistrictsTransforms");
    this.StationsTransforms = $injector.get("StationsTransforms");

    this.onUpdate = this.Events.getUpdateEvent("city");
    this.onUpdateDetail = this.Events.getUpdateEvent("cityDetails");
    this.onUpdateBookingConf = this.Events.getUpdateEvent("cityBookingConf");
    this.onUpdateCancellation = this.Events.getUpdateEvent("cityCancellation");
    this.onUpdateCaptainAppConf = this.Events.getUpdateEvent("cityCaptainApp");
    this.onUpdatePeakPricingConf = this.Events.getUpdateEvent("cityPeakConf");
    this.onUpdateCallCaptainAllowanceConf = this.Events.getUpdateEvent(
      "callCaptainAllowance"
    );
    this.onUpdateCancellationCompensationConf = this.Events.getUpdateEvent(
      "cancellationCompensation"
    );
    this.onUpdateTimezone = this.Events.getUpdateEvent("cityTimezone");
    this.onUpdatePricingConf = this.Events.getUpdateEvent(
      "updatePricingParams"
    );
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;

    this.isDistanceThresholdDisabled = true;
    this.isVariablePlanMaxThresholdsDisabled = true;
    this.isDispatcherConfigDisabled = true;
    this.isMaxDistanceForAutoSkipDisabled = true;
    this.isMaxTimeForAutoSkipDisabled = true;
    this.isWaitingTimeDisabled = true;
    this.isDelayOptionsDisabled = true;
    this.isTransferredCompensationDisabled = true;
    this.isPaymentOptionsEditable = false;
    this.isDelayOptionsEditable = false;
    this.isReferOptions = false;
    this.cityLoaded = false;
    this.isPricingConfEditable = false;
    this.RoundingOffList = this.Lists.roundingOffList;
    this.distanceTypes = this.Lists.distanceTypes;
    this.Upload = Upload;

    this.isCityCategoryTopupDisabled = true;
    this.updateSkipStationTopupAmount = this.updateSkipStationTopupAmount.bind(
      this
    );
    this.updateDistanceThreshold = this.updateDistanceThreshold.bind(this);
    this.updateVariablePlanMaxThreshold = this.updateVariablePlanMaxThreshold.bind(
      this
    );
    this.updateDispatcherConfiguration = this.updateDispatcherConfiguration.bind(
      this
    );
    this.updateDistanceTypeConfiguration = this.updateDistanceTypeConfiguration.bind(
      this
    );
    this.updateAutoSkipStationConfiguration = this.updateAutoSkipStationConfiguration.bind(
      this
    );
    this.updateWaitingTimeConfiguration = this.updateWaitingTimeConfiguration.bind(
      this
    );
    this.saveDelayoptions = this.saveDelayoptions.bind(this);
    this.saveTransferredCompensation = this.saveTransferredCompensation.bind(
      this
    );

    this.availableCityLanguages = cloneDeep(this.Lists.availableCityLanguages);
    this.isPaymentOptionsEditable = false;
    this.paymentOptions = {};
    this.otherPaymentOptions = {};
    this.cityId = this.$stateParams.id;
    this.activeCategoryId = undefined;
  }

  $onInit() {
    this.startCase = startCase;
    const formatContact = (items) => {
      const options = {};
      options.emails = mapKeyValue(items.emails);
      options.hotlines = mapKeyValue(items.hotlines);
      options.numbers = mapKeyValue(items.numbers);

      return options;
    };
    const onUpdateDetail = (options) => {
      const contact = formatContact(assign(this.city.contact, options));

      this.City.updateAction(this.$stateParams.id, "update_contacts", {
        contacts: contact,
      }).$promise.then(() => {
        this.Events.emit(
          this.showNotificationEvent,
          this.Messages.updateMessage("city")
        );
      });
    };
    const onUpdate = (item) => {
      const updatedItem = {};
      if (item.key === "timezone") item.value = toMilliseconds(item.value);
      updatedItem[item.key] =
        typeof item.value !== "undefined"
          ? item.value
          : item.name
          ? item.name._id
          : null;

      this.City.updateAction(
        this.$stateParams.id,
        item.methodName,
        updatedItem
      ).$promise.then(
        () => {
          this.city[item.key].isDisabled = true;
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.updateMessage("city", item.key)
          );
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    const onUpdateBookingConf = (item) => {
      const book_options = Object.assign({}, this.bookOptions);

      book_options[item.key] =
        item.key === "max_debt" ? item.value * 100 : item.value;
      this.City.updateAction(this.$stateParams.id, "update_book_options", {
        book_options,
      }).$promise.then(
        () => {
          this.city.book_options[item.key].isDisabled = true;
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.updateMessage("city", item.key)
          );
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    const onUpdateCancellation = (options) => {
      const formatted = this.CityTransforms.formatCancellation(
        options,
        options.name
      );
      const data = { [options.name]: formatted };

      this.City.updateAction(
        this.$stateParams.id,
        "update_cancellation_policy",
        data
      ).$promise.then(
        (response) => {
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.cancellationPolicy()
          );
          this.city = this.CityTransforms.justify(response);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    const onUpdateCallCaptainAllowance = (options) => {
      this.City.updateAction(
        this.$stateParams.id,
        "update_call_captain_allowance",
        { call_captain_allowance: options }
      ).$promise.then(
        (response) => {
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.updateMessage("city", "captain app configuration")
          );
          this.city = this.CityTransforms.justify(response);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };
    const onUpdateCancellationCompensation = (options) => {
      this.City.updateAction(
        this.$stateParams.id,
        "update_ride_cancellation_compensation",
        { ride_cancellation_compensation: options * 100 }
      ).$promise.then(
        (response) => {
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.updateMessage("city", "captain app configuration")
          );
          this.city = this.CityTransforms.justify(response);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };
    const getHexStatus = () => {
      this.City.getHexStatus(this.$stateParams.id).$promise.then((res) => {
        if (
          res.status === "done" ||
          res.status === "inprogress" ||
          res.status === "started"
        ) {
          this.generatedHexes = true;
        }
        this.hexStatus = res.status;
      });
    };
    getHexStatus();

    this.getOtherPaymentServiceOptions();

    this.City.get(this.$stateParams.id, {
      "include[]": ["supply-finances"],
      isCityRequired: false,
    }).$promise.then(
      (response) => {
        this.bookOptions = Object.assign({}, response.book_options);
        this.city = this.CityTransforms.justify(response);
        // English
        this.currentCityLanguages = !this.city.languages.includes("en")
          ? [this.availableCityLanguages[0]]
          : [];
        this.city.languages.forEach((language) => {
          this.currentCityLanguages.push(
            this.availableCityLanguages.find((ac) => ac.code === language)
          );
        });
        this.cityLoaded = true;
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );

    this.getSystemCategories();

    this.District.getAll({
      city: this.$stateParams.id,
      limit: 1000,
    }).$promise.then(
      (response) => {
        this.districts = this.DistrictsTransforms.justifyPolygon(response.hits);
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );

    this.Station.getAll({
      city: this.$stateParams.id,
      limit: 1000,
    }).$promise.then(
      (response) => {
        this.stations = this.StationsTransforms.justify(response.hits);
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );

    this.Events.on(this.onUpdate, onUpdate);
    this.Events.on(this.onUpdateDetail, onUpdateDetail);
    this.Events.on(this.onUpdateBookingConf, onUpdateBookingConf);
    this.Events.on(this.onUpdateCancellation, onUpdateCancellation);
    this.Events.on(
      this.onUpdateCallCaptainAllowanceConf,
      onUpdateCallCaptainAllowance
    );
    this.Events.on(
      this.onUpdateCancellationCompensationConf,
      onUpdateCancellationCompensation
    );
    this.Events.on(this.onUpdatePricingConf, this.updatePricingConf.bind(this));
  }

  $onDestroy() {
    this.$mdDialog.cancel();
  }

  onBookingInspectionChange(value) {
    const book_options = Object.assign({}, this.bookOptions);

    book_options.booking_inspection = {
      enabled: value,
    };

    this.City.updateAction(this.$stateParams.id, "update_book_options", {
      book_options,
    }).$promise.then(
      () => {
        this.Events.emit(
          this.showNotificationEvent,
          this.Messages.updateMessage("city", "booking_inspection")
        );
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  getSystemCategories() {
    this.systemCategories = [];
    this.City.getRideCategory().$promise.then((response) => {
      if (response.hits) {
        this.systemCategories = response.hits.map(
          ({ _id: id, _source: category }) => ({
            id,
            title: `${category.ride_type} ${category.service_type}`,
          })
        );
      }
    });
  }

  downloadPolygon() {
    this.City.downloadPolygon(this.$stateParams.id).$promise.then(
      (response) => {
        const data = JSON.parse(angular.toJson(response));
        const blob = new Blob([Object.values(data).join("")], {
          type: "text/xml",
        });
        saveAs(blob, "city.kml");
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  editPaymentOptions() {
    this.isPaymentOptionsEditable = true;
  }

  editOtherPaymentServiceOptions() {
    this.isOtherPaymentServiceOptionsEditable = true;
  }

  foundPayment(item) {
    if (this.city.available_payment_options) {
      return this.city.available_payment_options.includes(item);
    }
    return false;
  }

  getOtherPaymentServiceOptions() {
    this.City.getOtherPaymentServiceOptions(this.$stateParams.id).$promise.then(
      (res) => {
        this.otherPaymentServiceOptions = res;
      }
    );
  }

  savePaymentOptions() {
    this.selectedPaymentOptions = [];
    this.isPaymentOptionsEditable = false;
    Object.keys(this.paymentOptions).forEach((option) => {
      if (this.paymentOptions[option]) {
        this.selectedPaymentOptions.push(option);
      }
    });

    const payment_options = this.selectedPaymentOptions;
    this.City.updateAction(this.$stateParams.id, "update_payment_options", {
      payment_options,
    }).$promise.then(
      (response) => {
        this.Events.emit(this.showNotificationEvent, {
          message: "Payment options modified successfully",
        });
        this.city = this.CityTransforms.justify(response);
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  saveOtherPaymentServiceOptions() {
    this.selectedPaymentOptions = [];
    Object.keys(this.otherPaymentOptions).forEach((option) => {
      if (this.otherPaymentOptions[option]) {
        this.selectedPaymentOptions.push(option);
      }
    });
    this.City.updateOtherPaymentServiceOptions(this.$stateParams.id, {
      payment_options: this.selectedPaymentOptions,
    }).$promise.then(
      () => {
        this.Events.emit(this.showNotificationEvent, {
          message: "Payment options modified successfully",
        });
        this.isOtherPaymentServiceOptionsEditable = false;
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  editDelayoptions() {
    this.isDelayOptionsEditable = true;
  }

  saveDelayoptions() {
    const delay_compensation_policy = {};
    delay_compensation_policy.amount =
      this.city.delay_compensation_policy.amount * 100;
    delay_compensation_policy.threshold =
      this.city.delay_compensation_policy.threshold * 60000;
    delay_compensation_policy.expiry =
      this.city.delay_compensation_policy.expiry * 86400000;
    this.City.updateAction(
      this.$stateParams.id,
      "update_delay_compensation_policy",
      { delay_compensation_policy }
    ).$promise.then(
      (response) => {
        this.isDelayOptionsDisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message: "Delay Compensation policy updated successfully",
        });
        this.city = this.CityTransforms.justify(response);
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  saveTransferredCompensation() {
    const transfer_compensation_policy = {};
    transfer_compensation_policy.amount =
      this.city.transfer_compensation_policy.amount * 100;
    transfer_compensation_policy.expiry =
      this.city.transfer_compensation_policy.expiry * 86400000;

    this.City.updateAction(
      this.$stateParams.id,
      "update_transfer_compensation_policy",
      { transfer_compensation_policy }
    ).$promise.then(
      (response) => {
        this.isTransferredCompensationDisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message:
            "Transferred Booking Compensation policy updated successfully",
        });
        this.city = this.CityTransforms.justify(response);
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }
  editReferOptions() {
    this.isReferOptions = true;
    this.city.refer_options.description_i18n.isDisabled = false;
    this.city.refer_options.message_i18n.isDisabled = false;
  }

  onChangeCategory(activeCategory) {
    if (!isNil(this.city.ride_categories)) {
      const selectedCategoryDetails = this.city.ride_categories.find(
        (categoryItem) => categoryItem.category === activeCategory.id
      );
      this.activeCategoryId = selectedCategoryDetails.ride_type;
      this.noPricingConfig = selectedCategoryDetails.features.find(
        (feature) =>
          feature.name === "pricing_version" && feature.value === "fixed"
      );

      this.cityCategoryPricing = selectedCategoryDetails.features.find(
        (feature) =>
          feature.name === "pricing_version" && feature.value === "dynamic"
      );
      this.cityCategoryDistanceType = selectedCategoryDetails.features.find(
        (feature) => feature.name === "distance_type"
      );
      const categoryDispatcherConfig = selectedCategoryDetails.features.find(
        (feature) => feature.name === "dispatcher_config"
      );
      const autoSkipStationConfig = selectedCategoryDetails.features.find(
        (feature) => feature.name === "auto_skip_station_config"
      );

      this.cityCategoryDispatcher = categoryDispatcherConfig
        ? categoryDispatcherConfig.value
        : "";

      this.autoSkipStationConfig =
        autoSkipStationConfig && autoSkipStationConfig.value
          ? {
              ...autoSkipStationConfig.value,
              skip_time:
                Number(autoSkipStationConfig.value.skip_time) > 0
                  ? Number(autoSkipStationConfig.value.skip_time) / 60 // Convert seconds to minutes
                  : 0,
            }
          : { skip_distance: 0, skip_time: 0 };

      const categoryWaitingTimeConfiguration = selectedCategoryDetails.features.find(
        (feature) => feature.name === "waiting_time"
      );
      this.cityCategoryWaitingTime = categoryWaitingTimeConfiguration
        ? categoryWaitingTimeConfiguration.value
        : "";

      const categoryTopUpConfiguration = selectedCategoryDetails.features.find(
        (feature) => feature.name === "top_up"
      );
      this.cityCategoryTopup = categoryTopUpConfiguration
        ? categoryTopUpConfiguration.value / constants.currencyBy
        : "";
    }
    if (!isNil(this.cityCategoryPricing)) {
      this.pricing_parameters = { ...this.cityCategoryPricing.config };
      this.pricing_parameters.base_fare /= constants.currencyBy;
      this.pricing_parameters.distance_bucket_fare /= constants.currencyBy;
      this.pricing_parameters.time_bucket_fare /= constants.currencyBy;
      this.pricing_parameters.maximum_fare /= constants.currencyBy;
      this.pricing_parameters.rounding_off_limit /= constants.currencyBy;
      this.pricing_parameters.min_peak /= constants.currencyBy;
      this.pricing_parameters.max_peak /= constants.currencyBy;
    } else this.pricing_parameters = {};

    if (!isNil(this.cityCategoryDistanceType)) {
      this.distanceType = find(
        (i) => i.name === this.cityCategoryDistanceType.value
      )(this.distanceTypes);
      this.distanceType.isDisabled = true;
      this.distanceType.value = this.distanceType.name;
    }
  }

  updatePricingConf(data) {
    let {
      base_fare,
      distance_bucket_fare,
      distance_bucket_size,
      time_bucket_fare,
      time_bucket_size,
      maximum_fare,
      rounding_off_limit,
      base_time,
      base_distance,
      min_peak,
      max_peak,
      peak_multiplier_step,
    } = data;
    // Multiplying fares by 100
    base_fare = multiplyFloatingPointByCurrency(base_fare);
    distance_bucket_fare = multiplyFloatingPointByCurrency(
      distance_bucket_fare
    );
    time_bucket_fare = multiplyFloatingPointByCurrency(time_bucket_fare);
    maximum_fare = multiplyFloatingPointByCurrency(maximum_fare);
    max_peak = multiplyFloatingPointByCurrency(max_peak);
    min_peak = multiplyFloatingPointByCurrency(min_peak);
    rounding_off_limit *= constants.currencyBy;

    const pricing_parameters = {
      base_fare,
      distance_bucket_fare,
      distance_bucket_size,
      time_bucket_fare,
      time_bucket_size,
      maximum_fare,
      rounding_off_limit,
      base_time,
      base_distance,
      min_peak,
      max_peak,
      peak_multiplier_step,
    };

    this.City.updateCategory(
      this.$stateParams.id,
      this.activeCategory.id,
      pricing_parameters,
      "dynamic_pricing"
    ).$promise.then(
      (response) => {
        this.isPricingConfEditable = false;
        this.city = this.CityTransforms.justify(response);
        this.Events.emit(this.showNotificationEvent, {
          message: "City Pricing Configuration is updated successfully",
        });
      },
      (response) => {
        this.Events.emit(this.errorEvent, response.data);
        this.pricing_parameters = {};
      }
    );
  }

  updateDispatcherConfiguration() {
    const dispatcherConfig = { ...this.cityCategoryDispatcher };
    this.City.updateDispatcherConfiguration(
      this.$stateParams.id,
      this.activeCategory.id,
      dispatcherConfig
    ).$promise.then(
      () => {
        this.isDispatcherConfigDisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message: "City Dispatcher Configuration is updated successfully",
        });
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  updateDistanceTypeConfiguration() {
    const type = { distance_type: this.distanceType.value };

    this.City.updateCategory(
      this.$stateParams.id,
      this.activeCategory.id,
      type,
      "distance_type"
    ).$promise.then(
      (response) => {
        this.city = this.CityTransforms.justify(response);
        this.distanceType.isDisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message: "City Category Distance Type is updated successfully",
        });
      },
      (response) => {
        this.Events.emit(this.errorEvent, response.data);
      }
    );
  }

  updateAutoSkipStationConfiguration() {
    const { skip_time, skip_distance } = this.autoSkipStationConfig;
    const skipTimeSeconds = Number(skip_time) > 0 ? Number(skip_time) * 60 : 0; // Convert minutes to seconds

    this.City.updateAutoSkipStationConfiguration(
      this.$stateParams.id,
      this.activeCategory.id,
      { skip_distance, skip_time: skipTimeSeconds }
    ).$promise.then(
      () => {
        this.isMaxDistanceForAutoSkipDisabled = true;
        this.isMaxTimeForAutoSkipDisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message:
            "City auto skip station configuration is updated successfully",
        });
      },
      (response) => {
        this.Events.emit(this.errorEvent, response.data);
      }
    );
  }

  updateWaitingTimeConfiguration() {
    const waitingTime = { waiting_time: this.cityCategoryWaitingTime };
    this.City.updateWaitingTimeConfiguration(
      this.$stateParams.id,
      this.activeCategory.id,
      waitingTime
    ).$promise.then(
      () => {
        this.isWaitingTimeDisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message: "City Waiting Time Configuration is updated successfully",
        });
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  updateSkipStationTopupAmount() {
    const top_up = this.cityCategoryTopup * constants.currencyBy;

    this.City.putAction(
      this.$stateParams.id,
      `category/${this.activeCategory.id}/top_up`,
      { top_up }
    ).$promise.then(
      (response) => {
        this.isCityCategoryTopupDisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message: "City Skip Station Topup Amount is updated successfully",
        });
        this.city.ride_categories = response.ride_categories;
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  updateVariablePlanMaxThreshold() {
    const {
      variable_plan_maximum_thresholds,
    } = this.city.supply_finances_config;

    this.City.updateVariablePlanMaxThreshold(this.$stateParams.id, {
      variable_plan_maximum_thresholds,
    }).$promise.then(
      () => {
        this.isVariablePlanMaxThresholdsDisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message:
            "City Variable Plan Maximum Thresholds is updated successfully",
        });
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  updateDistanceThreshold() {
    const {
      distance_threshold: { auto_arrive, manual_arrive, manual_depart },
    } = this.city;

    this.City.updateDistanceThreshold(this.$stateParams.id, {
      distance_threshold: { auto_arrive, manual_arrive, manual_depart },
    }).$promise.then(
      () => {
        this.isDistanceThresholdDisabled = true;
        this.Events.emit(this.showNotificationEvent, {
          message: "City Distance Threshold is updated successfully",
        });
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  saveReferOptions() {
    this.isReferOptions = false;
    const refer_options = this.constructReferOptionsObject();
    this.City.updateAction(this.$stateParams.id, "update_refer_options", {
      refer_options,
    }).$promise.then(
      (response) => {
        this.Events.emit(
          this.showNotificationEvent,
          this.Messages.referOptionsMessage()
        );
        this.city = this.CityTransforms.justify(response);
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }

  constructReferOptionsObject() {
    return {
      amount: this.city.refer_options.amount.value * constants.currencyBy,
      description_i18n: {
        ar: this.city.refer_options.description_i18n.ar,
        en: this.city.refer_options.description_i18n.en,
      },
      message_i18n: {
        ar: this.city.refer_options.message_i18n.ar,
        en: this.city.refer_options.message_i18n.en,
      },
    };
  }

  clearKML() {
    delete this.kml_file;
  }
  uploadKML() {
    if (!isNil(this.kml_file)) {
      this.isUploading = true;
      const data = {
        document: this.kml_file,
      };
      this.Upload.upload({
        url: apis.city + this.$stateParams.id + "/upload_kml",
        data,
      }).then(
        () => {
          this.Events.emit(this.showNotificationEvent, {
            message:
              "Your file has been uploaded successfully, please refresh the page to see the changes",
          });
          this.isUploading = false;
          this.uploadSuccess = true;
          this.clearKML();
        },
        (response) => {
          if (response.data.overlaps) {
            const overlappingKmlFile = new File(
              [response.data.overlaps],
              `${this.city.name_i18n.en} overlapping.kml`
            );
            saveAs(overlappingKmlFile);
          }
          const message = response.data.message || "Can't upload your file !";
          this.clearKML();
          this.Events.emit(this.errorEvent, { message });
          this.isUploading = false;
        }
      );
    }
  }
  generateHexes() {
    const hex_resolution = 7;
    this.City.updateAction(this.$stateParams.id, "hex_generations", {
      hex_resolution,
    })
      .$promise.then((response) => {
        this.Events.emit(this.showNotificationEvent, {
          message: `Resolution ${hex_resolution} hexes generation process started successfully`,
        });
        this.generatedHexes = true;
        this.hexStatus = response.status;
      })
      .catch((err) => this.Events.emit(this.errorEvent, err.data));
  }
  handleActivation() {
    const isActive = this.city.active.value;
    const message = isActive ? "Deactivate" : "Activate";
    const confirm = this.$mdDialog
      .confirm()
      .title(`Are you sure you want to ${message} this city?`)
      .ok(message)
      .cancel("Cancel");

    this.$mdDialog.show(confirm).then(
      () => {
        const active = !this.city.active.value;
        const methodName = active ? "activate" : "deactivate";

        this.City.updateAction(this.$stateParams.id, methodName).$promise.then(
          (response) => {
            this.city = this.CityTransforms.justify(response);
            this.Events.emit(
              this.showNotificationEvent,
              this.Messages.enableRideMessage("city", message)
            );
          },
          (response) => this.Events.emit(this.errorEvent, response.data)
        );
      },
      () => {}
    );
  }
  handleShowInApp() {
    const showInApp = this.city.show_in_app.value;
    const message = showInApp ? "Hide From App" : "Show In App";
    const confirm = this.$mdDialog
      .confirm()
      .title(`Are you sure you want to ${message} this city?`)
      .ok(message)
      .cancel("Cancel");

    this.$mdDialog.show(confirm).then(
      () => {
        const methodName = showInApp ? "hide_from_app" : "show_in_app";
        this.City.updateAction(this.$stateParams.id, methodName).$promise.then(
          (response) => {
            this.city = this.CityTransforms.justify(response);
            this.Events.emit(
              this.showNotificationEvent,
              this.Messages.enableRideMessage("city", message)
            );
          },
          (response) => this.Events.emit(this.errorEvent, response.data)
        );
      },
      () => {}
    );
  }

  handleShowInCaptainApp() {
    if (!this.city.show_in_captain_app.value) {
      const areAllAvailableLanguagesFilled = this.currentCityLanguages.every(
        ({ code }) => this.city.name_i18n[code]
      );

      if (areAllAvailableLanguagesFilled) {
        this.toggleShowInCaptainApp(true);
      } else {
        this.Events.emit(this.errorEvent, {
          message: `Please fill the city name with all ${this.currentCityLanguages.length} languages fields and use the correct script since the captain’s will see this on their application`,
        });
      }
    } else {
      this.toggleShowInCaptainApp(false);
    }
  }

  toggleShowInCaptainApp(showInCaptainApp) {
    this.City.patchAction(this.$stateParams.id, "show_in_captain_app", {
      show_in_captain_app: showInCaptainApp,
    }).$promise.then(
      ({ show_in_captain_app }) => {
        this.city.show_in_captain_app.value = show_in_captain_app;
        this.Events.emit(this.showNotificationEvent, {
          message: `This city is ${
            show_in_captain_app ? "shown" : "hidden"
          } successfully`,
        });
      },
      (response) => {
        this.Events.emit(this.errorEvent, response.data);
      }
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/city/city.controller.js